import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthorizationService } from '../../core/services/authorization.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { timer } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  forgotForm: FormGroup;
  submitted = null;
  requested: boolean = false;
  email: string;
  resendLink: boolean = true;

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private forgotPwdService: AuthorizationService) {
    this.createForm();
  }

  ngOnInit() {
  }
  private createForm() {
    this.forgotForm = this.formBuilder.group({
      email: ['', [Validators.email, Validators.required]],
    });
  }

  ngOnDestroy() {
  }

  resetPassword(resend: boolean = false) {
    if (!this.resendLink) return;
    this.submitted = false;
    if (this.forgotForm.invalid) {
      return;
    }

    this.submitted = true;
    if (this.forgotForm.valid) {
      this.email = this.forgotForm.value.email;
    }

    if (this.email) {
      this.requested = true;
      this.resendLink = false;
      timer(30000)
        .takeUntil(componentDestroyed(this))
        .subscribe((tick) => {
          this.resendLink = true;
        });
      this.forgotPwdService.forgotPasssword({ email: this.email })
        .takeUntil(componentDestroyed(this))
        .subscribe(_ => {
          if (resend) {
            this.toastrService.success('Link has been sent to your registered email.');
          }
          this.submitted = false;
        });
    }
  }

  get f() { return this.forgotForm.controls }

  gotoLogin() {
    this.router.navigateByUrl('login');
  }

}
